import "./App.css";
import Navigation from "./components/navigation/navigation";
import { NotificationsProvider } from "reapop";

function App() {
  document.title = "Youniverse";
  return (
    <NotificationsProvider>
      <Navigation />
    </NotificationsProvider>
  );
}

export default App;
